// extracted by mini-css-extract-plugin
export default {"speechBubble":"SpeechBubble_speechBubble__x6flv"};